import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { EquipmentService } from '../../state-services/equipment.service';
import { Aircrafts } from '../../models/equipment.model';
import * as EquipmentActions from './equipment.actions';
import { exhaustMap, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class EquipmentEffects {
  loadingEquipment$ = createEffect(() =>
    this.actions$.pipe(
      ofType(EquipmentActions.loadingEquipment),
      exhaustMap(() =>
        this.equipmentService.getAllDrones().pipe(
          map((drones) =>
            EquipmentActions.loadingEquipmentSuccess({
              equipment: {
                aircrafts: drones.map(
                  (drone): Aircrafts => ({
                    name: drone.name,
                    unitNumber: drone.unitNumber,
                    serialNumber: drone.unitNumber,
                    description: '',
                  }),
                ),
                software: [],
              },
            }),
          ),
          catchError((error) =>
            of(EquipmentActions.loadingEquipmentError({ error: error })),
          ),
        ),
      ),
    ),
  );

  newAircraft$ = createEffect(() =>
    this.actions$.pipe(
      ofType(EquipmentActions.activatingAircraftSuccess),
      map(({ companyId }) =>
        EquipmentActions.loadingEquipment({
          companyId: companyId,
        }),
      ),
    ),
  );

  activateNewAircraft$ = createEffect(() =>
    this.actions$.pipe(
      ofType(EquipmentActions.activatingAircraft),
      exhaustMap(({ serial, companyId }) =>
        this.equipmentService.activateEquipment(serial, companyId).pipe(
          map(() =>
            EquipmentActions.activatingAircraftSuccess({
              companyId: companyId,
            }),
          ),
          catchError((error) =>
            of(EquipmentActions.activatingAircraftError({ error: error })),
          ),
        ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private equipmentService: EquipmentService,
  ) {}
}
